'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {

    $('.show-more-text', this).on('click', function (e) {
        e.preventDefault();

        var $wrap = $(this).closest('.cms-text');

        $('.text-long', $wrap).removeClass('hidden');
        $('.text-short', $wrap).addClass('hidden');
        $(this).hide();
    });
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/initializers/showHide.js
// module id = 949
// module chunks = 0